import {Algorithm} from "./Algorithm";
import {DraggableViewer} from "./DraggableViewer";
import $ from "jquery";
import {UserInputOptionSelector} from "./UserInputOptionSelector";

export class Tsar extends Algorithm {

  constructor(container) {
    super(container);

    this.weatherOverrides = {
      equipment: {
        HEAT: "snowing",
        COOL: "sunny",
      }
    };
  }


  initWidgets() {
    // Customize for this algorithm here if needed,
    this.draggableMap = new DraggableViewer({
      zone: this.$container.find(".widgets-container .widget .map-zone"),
      images: this.$container.find(".widgets-container .widget .map-image"),
    });
  }

  buildRangesMap() {
    this.rangesMap = this.userCombinationData.map(({key, title}, index) => {
      const [sites, equipment] = title.split("-").map(s => s.trim());
      return {key, sites, equipment, index};
    });
  }

  initUserInputs() {
    super.initUserInputs();

    this.sitesTestedSelector = new UserInputOptionSelector(this.$container.find(`.user-input-selector-container[data-user-input-id="sites_tested"]`));
    this.sitesTestedSelector.on("userInputValueChanged", (value) => this.onUserInput(value));

    this.equipmentTestsSelector = new UserInputOptionSelector(this.$container.find(`.user-input-selector-container[data-user-input-id="equipment_tests"]`));
    this.equipmentTestsSelector.on("userInputValueChanged", (value) => this.onUserInput(value));
  }

  onUserInput(value) {
    const targetCombination = this.findUserCombination(this.sitesTestedSelector.getRealValue(), this.equipmentTestsSelector.getRealValue());

    // Update KPIs
    this.selectKPIs(targetCombination.key);

    // Update map
    this.draggableMap.show(targetCombination.key);

    this.sendWeatherOverride();
  }

  sendWeatherOverride() {
    if (!this.isActive) return;

    const targetCombination = this.findUserCombination(this.sitesTestedSelector.getRealValue(), this.equipmentTestsSelector.getRealValue());

    app.sendScreenBridgeMessage(`weatherOverride ${this.weatherOverrides.equipment[targetCombination.equipment] ?? "none"}`);
  }

  start() {
    super.start();

    this.sendWeatherOverride();
  }

  findUserCombination(sites, equipment) {
    // Let's return the entry where the value fits the correct values
    // Returns the first element if there is no match (which should not happen if data is set correctly)
    return this.rangesMap.find(entry => entry.sites == sites && entry.equipment == equipment) ?? this.rangesMap[0];
  }

  onBuildingChange(type) {
    super.onBuildingChange(type);

    // Dummy equipment -  Set all related equipment to active
    this.updateAllBuildingsEquipments("active");
  }

  resetUserInputs() {
    this.draggableMap.reset(0);
    this.sitesTestedSelector.reset();
    this.equipmentTestsSelector.reset();
  }

}
